import React from 'react'

import { HEADLINE_CUTOFFS } from './Constants'
import { ListingHeadingH2, ListingHeadline, ListingSpan } from './Styled'

const ListingHeading = ({ listingOwnerName, headline }) => (
  <>
    <ListingHeadingH2>{listingOwnerName}</ListingHeadingH2>
    <ListingHeadline>
      <ListingSpan display={{ _: 'none', desktop: 'inline' }}>
        {headline.substring(0, HEADLINE_CUTOFFS.LARGE).trim()}
        {headline.length > HEADLINE_CUTOFFS.LARGE && '…'}
      </ListingSpan>
      <ListingSpan display={{ _: 'none', tablet: 'inline', desktop: 'none' }}>
        {headline.substring(0, HEADLINE_CUTOFFS.SMALL).trim()}
        {headline.length > HEADLINE_CUTOFFS.SMALL && '…'}
      </ListingSpan>
      <ListingSpan display={{ _: 'inline', tablet: 'none' }}>
        {headline.substring(0, HEADLINE_CUTOFFS.XS).trim()}
        {headline.length > HEADLINE_CUTOFFS.XS && '…'}
      </ListingSpan>
    </ListingHeadline>
  </>
)

export default ListingHeading
